import React from 'react'
import "./OurTeam.css"
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { faFacebookF, faLinkedinIn, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function OurTeam() {
    return (
        <section className='our-team'>
            <Container>
                <Row>
                    <div className='heading-holder mb-sm-3 mb-3'>
                        {/* <h2 className='pillars'>OUR PILLARS</h2> */}
                        <h3 className='section_heading'>Our Team</h3>
                    </div>
                    <Col lg={4} md={4} sm={6}>
                        <div className='team-holder-box mb-3'>
                            <img className="team-img" src={"/assets/Image/aboutus/our_team/image_1.png"} alt="team-img" />
                            <div className='text-holder ps-4'>
                                <h4>Andrew Max Fetcher</h4>
                                <h5>CEO</h5>

                            </div>
                            <div className="social-icon-holder">
                                <div className="icon-holder">
                                    <Link to="https://www.facebook.com/login/" target="_blank" className="icon-target"><FontAwesomeIcon className="icon" icon={faFacebookF} /></Link>
                                </div>

                                <div className="icon-holder">
                                    <Link to="https://www.linkedin.com/home" target="_blank" className="icon-target"><FontAwesomeIcon className="icon" icon={faLinkedinIn} /></Link>
                                </div>

                                <div className="icon-holder">
                                    <Link to="https://x.com/i/flow/login" target="_blank" className="icon-target"><FontAwesomeIcon className="icon" icon={faTwitter} /></Link>
                                </div>
                            </div>
                            <div className='overlay-color'></div>
                        </div>
                    </Col>
                    <Col lg={4} md={4} sm={6} >
                        <div className='team-holder-box mb-3'>
                            <img className="team-img" src={"/assets/Image/aboutus/our_team/image_2.png"} alt="team-img" />
                            <div className='text-holder ps-4'>
                                <h4>Mike Holder</h4>
                                <h5>COO</h5>

                            </div>
                            <div className="social-icon-holder">
                                <div className="icon-holder">
                                    <Link to="https://www.facebook.com/login/" target="_blank" className="icon-target"><FontAwesomeIcon className="icon" icon={faFacebookF} /></Link>
                                </div>

                                <div className="icon-holder">
                                    <Link to="https://www.linkedin.com/home" target="_blank" className="icon-target"><FontAwesomeIcon className="icon" icon={faLinkedinIn} /></Link>
                                </div>

                                <div className="icon-holder">
                                    <Link to="https://x.com/i/flow/login" target="_blank" className="icon-target"><FontAwesomeIcon className="icon" icon={faTwitter} /></Link>
                                </div>
                            </div>
                            <div className='overlay-color'></div>

                        </div>
                    </Col>
                    <Col lg={4} md={4} sm={6}>
                        <div className='team-holder-box mb-3'>
                            <img className="team-img" src={"/assets/Image/aboutus/our_team/image_3.png"} alt="team-img" />
                            <div className='text-holder ps-4'>
                                <h4>Andrew Max Fetcher</h4>
                                <h5>CEO</h5>

                            </div>
                            <div className="social-icon-holder">
                                <div className="icon-holder">
                                    <Link to="https://www.facebook.com/login/" target="_blank" className="icon-target"><FontAwesomeIcon className="icon" icon={faFacebookF} /></Link>
                                </div>

                                <div className="icon-holder">
                                    <Link to="https://www.linkedin.com/home" target="_blank" className="icon-target"><FontAwesomeIcon className="icon" icon={faLinkedinIn} /></Link>
                                </div>

                                <div className="icon-holder">
                                    <Link to="https://x.com/i/flow/login" target="_blank" className="icon-target"><FontAwesomeIcon className="icon" icon={faTwitter} /></Link>
                                </div>
                            </div>
                            <div className='overlay-color'></div>

                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
